<template>
	<div v-if="processes && this.customer">
		<div
			class="even:bg-gray-100 odd:bg-gray-300 rounded cursor-pointer"
			v-for="process in processes"
			@click="$router.push({ name: 'management.process.edit', params: { customer: customer.id, processId: process.id } })"
			:key="process.id"
		>
			<div class="py-4 px-8">
				<div class="grid mt-1 mb-1">
					<div>
						<div class="flex w-full space-x-4" style="align-items: center">
							<div class="w-4/12 flex">
								<div class="w-10" v-if="process.processType">
									<font-awesome-icon :icon="getProcessIcon(process.processType)" class="text-gray-500" />
								</div>
								<div class="w-32 font-bold truncate">{{ getDateFromDatetime(process.dateFormated) }}</div>
								<div class="font-bold truncate">{{ process.vehicle.licensePlate.text }}</div>
							</div>
							<div class="flex flex-grow font-bold">
								{{ getProcessTypeLabel(process) }}
							</div>
							<div class="font-bold justify-start w-1/12" style="text-align: start">
								{{ process.isClosed ? $t('closed') : $t('active').toLowerCase() }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<LoadingSpinner v-else />
</template>

<script>
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'CustomerProcessList',
	components: { LoadingSpinner },
	props: {
		customer: { required: true },
		processes: { required: true },
	},
	mixins: [Authentication],
	methods: {
		getDateFromDatetime(datetime) {
			return datetime.substring(0, 10);
		},
		getProcessIcon(type) {
			let icon = '';
			if (type === 'order_documentation') {
				icon = ['fa', 'wrench'];
			} else {
				icon = ['fas', 'car-crash'];
			}
			return icon;
		},
		getProcessNumber(process) {
			if (this.isUserAllowedInLevel2 && process.damageAssessorReferenceNumber != null) {
				return ' - ' + process.damageAssessorReferenceNumber;
			}
			if (this.isUserAllowedInLevel5or6 && process.repairShopReferenceNumber != null) {
				return ' - ' + process.repairShopReferenceNumber;
			}
			if (this.isUserAllowedInLevel3 && process.lawyerOfficeReferenceNumber != null) {
				return ' - ' + process.lawyerOfficeReferenceNumber;
			}
			return '';
		},
		getProcessTypeLabel(process) {
			const processType = process.process_type;
			let label = '';
			if (processType === 'comprehensive' && process.opposite_insurance_state === 'ohne_versicherung_selbstzahler') {
				label = this.$t('customer_order');
			}
			if (processType === 'liability') {
				label = this.$t('liability');
			} else if (processType === 'comprehensive') {
				label = this.$t('comprehensive');
			} else if (processType === 'order_documentation') {
				label = `${this.$t('order_documentation')} (${process.orderDocumentationType.name})`;
			}
			return (label = label + this.getProcessNumber(process));
		},
	},
};
</script>

<style scoped></style>
